// extracted by mini-css-extract-plugin
module.exports = {"QuizCreator":"_2R7qzaguoNb1IrpqmovVUu"};